import imageCompression from 'browser-image-compression';

/**
 * 업로드 공통 이미지 압축 — **해상도는 그대로 두고 용량만 줄인다.**
 *
 * - PNG 는 화질(quality) 조절이 먹지 않아 그대로 두면 장당 수 MB 가 된다(2026-09-23 이벤트 공지 12MB 사고).
 *   투명도를 유지하면서 가장 작게 나오는 WebP 로 변환한다.
 * - JPEG/WebP 는 포맷을 유지하고 화질만 낮춘다.
 * - GIF 는 애니메이션이 깨지므로 건드리지 않는다.
 * - 아주 큰 사진(긴 변 3000px 초과)만 안전장치로 축소한다 — 최신 폰 사진이 4000px 를 넘기 때문.
 */
const QUALITY = 0.85;
const MAX_EDGE = 3000;
const MAX_SIZE_MB = 8;

/** 확장자를 변환 포맷에 맞춘다 — 서버가 파일명 확장자로 형식을 판단한다. */
const withExtension = (filename: string, extension: string): string =>
    `${filename.replace(/\.[^.]+$/, '')}.${extension}`;

export const compressImage = async (file: File): Promise<File> => {
    // 애니메이션 GIF 는 압축하면 첫 프레임만 남는다
    if (file.type === 'image/gif') {
        return file;
    }

    const isPng: boolean = file.type === 'image/png';
    const targetType: string = isPng ? 'image/webp' : file.type;

    const compressed: Blob = await imageCompression(file, {
        maxSizeMB: MAX_SIZE_MB,
        initialQuality: QUALITY,
        fileType: targetType,
        // 긴 변이 MAX_EDGE 이하면 해상도를 유지하고, 초과할 때만 줄인다
        maxWidthOrHeight: MAX_EDGE,
        useWebWorker: true,
    });

    const name: string = isPng ? withExtension(file.name, 'webp') : file.name;
    return new File([compressed], name, { type: targetType });
};
